var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBadDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.0172,
    cy: 16.7308,
    r: 15.6586,
    fill: "#FA5100",
    stroke: "#FA5100",
    strokeWidth: 1.84218
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3401 18.0359C15.0534 18.0359 12.8659 19.1302 11.4885 20.9628C11.2104 21.3336 11.2847 21.8604 11.6555 22.137C12.0259 22.4177 12.552 22.3439 12.8308 21.9712C13.8924 20.5592 15.578 19.7166 17.3401 19.7166C19.1018 19.7166 20.787 20.5588 21.8485 21.9712C22.0136 22.1905 22.2657 22.3073 22.52 22.3073C22.6956 22.3073 22.8728 22.2519 23.0239 22.1374C23.3947 21.8608 23.4689 21.334 23.1908 20.9632C21.8139 19.1306 19.6267 18.0359 17.3401 18.0359Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0822 11.5696C12.8474 11.1678 12.3353 11.0284 11.9332 11.2703C10.0343 12.3831 8.69055 11.8443 8.61857 11.8156C8.20066 11.6291 7.70701 11.8137 7.51444 12.2317C7.32075 12.6518 7.5054 13.1519 7.92633 13.3444C7.97343 13.3671 8.60086 13.6459 9.59458 13.6459C10.4368 13.6459 11.5428 13.4451 12.7826 12.7174C13.1824 12.4838 13.317 11.969 13.0822 11.5696Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0639 11.8163C26.0081 11.8367 24.6598 12.3902 22.7489 11.271C22.3472 11.0314 21.8343 11.1708 21.5999 11.5702C21.3651 11.9701 21.4997 12.4844 21.8991 12.7181C23.1385 13.4458 24.2442 13.6466 25.0864 13.6466C26.0805 13.6466 26.7075 13.3677 26.7547 13.3451C27.1711 13.1545 27.3516 12.6646 27.1658 12.2444C26.9804 11.8265 26.4856 11.6317 26.0639 11.8163Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadDark);
export default __webpack_public_path__ + "static/media/badDark.1db5adfaebaf6fa959e3ab3fb2ef9e78.svg";
export { ForwardRef as ReactComponent };